import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { User } from "src/app/domains/internal";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class UserService {
  url = environment.apiUrl + "/auth";

  constructor(private http: HttpClient) {}

  getAll() {
    return this.http.get<User[]>(`${environment.apiUrl}/users`);
  }
  get() {
    return this.http.get<User>(`${environment.apiUrl}/auth/user`);
  }

  enableAccount(payload) {
    return this.http.post(this.url + "/enable_account", payload);
  }

  askResetPassword(payload) {
    return this.http.post(this.url + "/ask_reset_password", payload);
  }
  resetPassword(payload) {
    return this.http.post(this.url + "/reset_password", payload);
  }
}
